(function () {
  setTimeout(function() {
    const clickElts = document.querySelectorAll('.gaClick')
    console.log(`Found ${clickElts.length} items to process.`)

    if (clickElts.length === 0) return;
    
    [...clickElts].map((elt) => {
      try {
        elt.addEventListener("click", function (e) {
          console.log("Sending click event to GA4.")

          const event = 'userEvent'
          const eventAction = 'click'
          const eventCategory = location.href
          const eventLabel = e.target.getAttribute('data-ga-event-label') || '(not set)'

          const dataLayer = window.dataLayer || []

          dataLayer.push({
            event,
            eventCategory,
            eventAction,
            eventLabel,
          })
          console.debug(
            'dataLayer.push',
            {
              event,
              eventCategory,
              eventAction,
              eventLabel,
            },
            dataLayer
          )

        });
      } catch (e) {
        console.log(
          "Something wrong happened when setting up event handling for the menu items."
        );
      }
    });
  }, 1500)
})();